import { Enviroment } from "../../../enviroments";
import CookieService from "../../autenticacao/CookieService";
import { Api } from "../axios-config"

export interface autenticacao {
    autenticado: boolean
}

export interface IDetalheUsuarioCadastro {
    codigo?: number;
    nome: string;
    sobrenome?: string;
    cgcCnpj: string;
    email: string;
    login: string;
    senha: string;
    permiteEnvioEmail?: boolean;
    permiteEnvioWhatsApp?: boolean;
    dtNascimento: string;
    sexo: number;
    residencia_Exterior: boolean;
    codUsuCriacao?: number;
    codTema?: number;
    confirmarSenha?: string;
    ativo: boolean;
    administrador: boolean;

}


export interface IDetalheUsuario {
    codigo?: number;
    nome: string;
    sobrenome?: string;
    cgcCnpj?: string | null;
    documento?: string;
    email: string;
    login: string;
    senha: string;
    observacao?: string;
    permiteEnvioEmail: boolean;
    permiteEnvioWhatsApp: boolean;
    dtNascimento?: Date;
    sexo: number;
    imagemPerfil?: string;
    dddtel?: string;
    telefone?: string;
    dddCel: string;
    celular: string;
    tipo?: string;
    codSistema?: number;
    codUsuModificacao?: number;
    codUsuCriacao?: number;
    codTema?: number;
    ativo: boolean;
    residencia_Exterior: boolean;
    administrador: boolean;
    desconto_Comissario: boolean;
    desconto_Indicacao: boolean;
    codigo_Usuario_Indicacao?: number | null;
    endereco: {
        codEndereco?: number;
        referencia?: string;
        tipoLogradouro?: string;
        logradouro?: string;
        numero?: string;
        bairro?: string;
        complemento?: string;
        cep?: string;
        codPais: number;
        codRegiao?: number;
        codEstado: number;
        codCidade: number;
        longitude?: string;
        latitude?: string;
        tipoEndereco?: string;
    }
    codigo_Liga_Favorito?: number  | null;
    codigo_Franquia_NBA_Favorito?: number | null;
    codigo_Time_Futebol_Favorito?: number | null;

}

export interface IDetalheUsuarioEdicao {
    codigo: number;
    nome: string;
    sobrenome: string;
    cgcCnpj: string;
    email: string;
    login: string;
    senha: string;
    observacao?: string;
    permiteEnvioEmail: boolean;
    permiteEnvioWhatsApp: boolean;
    dtNascimento?: Date;
    sexo: string;
    imagemPerfil?: string;
    dddtel?: string;
    telefone?: string;
    dddCel?: string;
    celular?: string;
    tipo?: string;
    codSistema?: number;
    codUsuModificacao?: number;
    codUsuCriacao?: number;
    codTema?: number;
    ativo: boolean;
    residencia_Exterior: boolean;
    administrador: boolean;
    desconto_Comissario: boolean;
    indicacao: boolean;
    codigo_Usuario_Indicacao: number;
    caminho_Imagem_Perfil: string;
    documento: string;
    dtCriacao: string;
    endereco?: {
        codEndereco?: number;
        referencia?: string;
        tipoLogradouro?: string;
        logradouro?: string;
        numero?: number;
        bairro?: string;
        complemento?: string;
        cep?: string;
        codPais?: number;
        codRegiao?: number;
        codEstado?: number;
        codCidade?: number;
        longitude?: string;
        latitude?: string;
        tipoEndereco?: string;
    }
    codigo_Liga_Favorito: number;
    codigo_Franquia_NBA_Favorito?: number;
    codigo_Time_Futebol_Favorito?: number;
}

export interface IListagemDadosUsuario {
    codigo: number;
    nome: string;
    email: string;
    codEndereco: number;
    login: string;
    sobrenome: string;
    dtUltimoAcesso: string;
    dddCel: string;
    celular: string;
    administrador: boolean;
    nomeSobrenome: string;
}

export interface IDadosRetornoUsuario {
    dado: IListagemDadosUsuario[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosRetorno {
    dado: IDadosRetornoUsuario;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosRetornoEdicao {
    dado: IDetalheUsuarioEdicao;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IFiltro {
    codigo: number;
    numeroPagina: number;
    tamanhoPagina: number;
    filtro: string;
    filtro2: string;
}

export interface IRespostaCreate {
    statusHTTP: number;
    status: number;
    processado: boolean;
    erros?: string[];
    mensagem: string;
    dado: any;
}

export interface IDadosRetornoImagemPerfil {
    data: {
        dado: IDadosRespImagemPerfil;
        erros: string;
        mensagem: string;
        processado: boolean;
        status: number;
        statusHTTP: number;
    }
}

export interface IDadosRespImagemPerfil {
    caminho: string;
    nome: string;
    nomeReal: string;
}

type TUsuariosComTotalCount = {
    data: IDadosRetornoUsuario;
    totalCount: number;
}



export interface IDadosRetornoMensagemPorUsuario {
    dado: IDetalheMensagemPorUsuario[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}



export interface IDetalheMensagemPorUsuario {
    codigo: number;
    codigo_Usuario: number;
    codigo_Liga: number;
    nome_Liga?: string;
    leilao: boolean;
    proposta: boolean;
    freeAgency: boolean;
    draft: boolean;
    partida: boolean;
    leilao_Geral: boolean;
    proposta_Geral: boolean;
    freeAgency_Geral: boolean;
    draft_Geral: boolean;
    partida_Geral: boolean;
    email: boolean;
    telegram: boolean;
    codUsuCriacao: number;

}

export interface IDetalheMensagemPorUsuarioCreate {
    codigo_Usuario: number;
    codigo_Liga?: number;
    nome_Liga?: string;
    leilao: boolean;
    proposta: boolean;
    freeAgency: boolean;
    email: boolean;
    telegram: boolean;
    codUsuCriacao: number;

}

export interface IDadosRetornoIndicacao {
    dado: IListaIndicados[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IListaIndicados {
    codigo: number;
    nome: string;
    email: string;
    quantidade_Indicacoes: number;
    indicados: IListaIndicacao[]
}

export interface IListaIndicacao {
    codigo: number;
    nome: string;
    email: string;
    data: string;
}


const getAllPaginado = async (page = 1, codigoUsuario: "", filter = ''): Promise<TUsuariosComTotalCount> => {
    const token = CookieService.get("access_token"); // localStorage.getItem("@Auth:token");        
    const { data, headers } = await Api.get(`/usuario/sql`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            Codigo: codigoUsuario !== "" ? codigoUsuario : null,
            NumeroPagina: page,
            TamanhoPagina: Enviroment.LIMITE_DE_LINHAS,
            Filtro: null,
            Filtro2: filter

        }
    });
    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getAll = async (): Promise<TUsuariosComTotalCount> => {
    const token = CookieService.get("access_token"); // localStorage.getItem("@Auth:token");        
    const { data, headers } = await Api.get(`/usuario`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getAllDropdownIndicados = async (): Promise<IDadosRetornoUsuario> => {
    const token = CookieService.get("access_token"); // localStorage.getItem("@Auth:token");        
    const { data, headers } = await Api.get(`/usuario/indicacao/dropdown`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}


const getById = async (codigo: number): Promise<IDadosRetornoEdicao> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoEdicao>(`/usuario/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getPermissoesMensagemByCodigoUsuario = async (codigo: number): Promise<IDadosRetornoMensagemPorUsuario> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoMensagemPorUsuario>(`/usuario/configuracao/mensagem/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getDadosIndicacao = async (codigoUsuarioIndicacao: number | null): Promise<IDadosRetornoIndicacao> => {
    const token = CookieService.get("access_token");

    const { data } = await Api.get<IDadosRetornoIndicacao>(`/usuario/indicacao/${codigoUsuarioIndicacao ?? 0}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const create = async (dados: Omit<IDetalheUsuario, "codigo" & "confirmarSenha">,): Promise<any> => {
    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user");
    dados.codUsuCriacao = user.codUsuario;
    return await Api.post(`/usuario`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}


const createConfiguracaoMensagem = async (dados: IDetalheMensagemPorUsuarioCreate[],): Promise<any> => {
    const token = CookieService.get("access_token");
    return await Api.post(`/usuario/configuracao/mensagem`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}



const createCadastro = async (dados: Omit<IDetalheUsuarioCadastro, "codigo" & "confirmarSenha">,): Promise<IRespostaCreate> => {

    dados.codUsuCriacao = 2;
    const nomes = dados.nome.split(" ");
    dados.sobrenome = nomes.length > 1 ? nomes.slice(-1)[0] : "";
    dados.codTema = dados.codTema ? dados.codTema : 1;
    const token = Enviroment.CHAVE_HOMOLOGACAO_CREATE;
    const { data } = await Api.post<IRespostaCreate>(`/usuario/cadastrar`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const updateById = async (codigo: number, dados: IDetalheUsuario): Promise<void> => {

    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user"); //localStorage.getItem("@Auth:login");        
    dados.codigo = codigo;
    dados.codUsuModificacao = user.codUsuario;
    return await Api.put(`/usuario`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });


}

const updateThemaById = async (codtema: number): Promise<void> => {

    const user = CookieService.get("access_user");
    const token = CookieService.get("access_token");

    return await Api.put(`/usuario/alterartema/${user.codUsuario}/${codtema}`, "", {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });


}

const upLoadImage = async (image: any): Promise<IDadosRetornoImagemPerfil> => {

    //const obj = CookieService.get("access_user");
    //const idUsuario = obj.codUsuario;

    const formData = new FormData();
    formData.append('img', image);

    const token = CookieService.get("access_token");
    return await Api.post('/FileUpload/usuario/perfil/upload', formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            'Access-Control-Allow-Origin': '*',
            'chavesessao': token
        }
    }).then(res => res)
        .catch((error) => error.response);
}

const deleteById = async (codigo: number): Promise<void> => {

    const token = CookieService.get("access_token");
    return await Api.delete(`/usuario/${codigo}/${Enviroment.ID_USUARIO_ACESSO}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}


export const UsuarioService = {
    getAll,
    getAllPaginado,
    getById,
    create,
    createCadastro,
    updateById,
    deleteById,
    updateThemaById,
    upLoadImage,
    createConfiguracaoMensagem,
    getPermissoesMensagemByCodigoUsuario,
    getAllDropdownIndicados,
    getDadosIndicacao
}